import { privateAxios } from 'services/api/privateAxios';

export const refuseOrder = (id, reason) =>
  privateAxios({
    method: 'post',
    url: `/orderboard/refuse/${id}`,
    data: { reason },
  });
